// extracted by mini-css-extract-plugin
export default {"div1":"orderCard_div1__TQYP6","div2":"orderCard_div2__rQHZp","p1":"orderCard_p1__5TGbf","p2":"orderCard_p2__ZsRkK"};